import {
  IntegrationType,
  PaymentEvent,
  PLATFORM_TYPE,
  PROCESSOR,
  SupportedAttributes,
  TerminalEventMonitoring,
} from '@lightspeed-payments/payments-terminal-sdk'
import { retailerSettingsManager } from '../../../../ng-compat/managers'
import { LSPAY_DATADOG_CLIENT_TOKEN } from './lspayConstants'

export const LSPAY_TERMINAL_EVENT = {
  RECOVERY_REQUESTED: 'payment.terminal.recovery.requested',
  RECOVERY_DEGRADED: 'payment.terminal.recovery.degraded',
  ACTIVE_TRANSACTION_OVERWRITTEN:
    'payment.terminal.active_transaction.overwritten',
} as const

type LSPayTerminalEvent = typeof LSPAY_TERMINAL_EVENT[keyof typeof LSPAY_TERMINAL_EVENT]

export const sendLSPayTerminalEvent = (
  instance: TerminalEventMonitoring | null,
  eventName: LSPayTerminalEvent,
  attributes?: SupportedAttributes
) => {
  // SDK 3.3.0 supports custom names at runtime but its PaymentEvent type has not caught up yet.
  instance?.sendEvent(eventName as PaymentEvent, attributes)
}

export const getMonitoringInstance = (
  outletId: string,
  isSandbox: boolean,
  integrationType: IntegrationType
) => {
  const instance = TerminalEventMonitoring.init({
    clientToken: LSPAY_DATADOG_CLIENT_TOKEN,
    env: isSandbox ? 'stage' : 'prod',
    product: 'x-series',
    pli: getPli(outletId),
    processor: PROCESSOR.STRIPE,
    integrationType,
    platformType: PLATFORM_TYPE.WEB,
    service: 'webregister',
    verbose: isSandbox,
  })

  const retailerId = retailerSettingsManager?.get()?.id
  if (retailerId) {
    instance.setPersistentAttributes({ retailerId })
  }

  return instance
}

const getPli = (outletId: string): string => {
  return 'lsx:' + outletId
}
